module.exports = __webpack_public_path__ + "img/convenio-de-practicas3.ef999d86.png";